import React from 'react';

import { Filter } from '@gogame/filters';

import { FILTER_STATUSES } from 'scenes/Applications/constants';
import { loadStatuses } from 'scenes/Applications/sources/filters';

export const Statuses = (props) => (
  <Filter.MultiSelect
    title={'Statuses'}
    placeholder={'All'}
    name={FILTER_STATUSES}
    variant={'outlined'}
    source={loadStatuses}
    withAll={false}
    {...props}
  />
);
